import { isNZLocale } from 'lib/PropertyUtils';
export const SALE_PRICE_OPTIONS = [
    {label: '$100,000', value: '100000'},
    {label: '$150,000', value: '150000'},
    {label: '$200,000', value: '200000'},
    {label: '$250,000', value: '250000'},
    {label: '$300,000', value: '300000'},
    {label: '$350,000', value: '350000'},
    {label: '$400,000', value: '400000'},
    {label: '$450,000', value: '450000'},
    {label: '$500,000', value: '500000'},
    {label: '$600,000', value: '600000'},
    {label: '$700,000', value: '700000'},
    {label: '$800,000', value: '800000'},
    {label: '$900,000', value: '900000'},
    {label: '$1,000,000', value: '1000000'},
    {label: '$1,250,000', value: '1250000'},
    {label: '$1,500,000', value: '1500000'},
    {label: '$2,000,000', value: '2000000'},
    {label: '$5,000,000', value: '5000000'},
    {label: '$10,000,000', value: '10000000'},
];

export const RENTAL_PRICE_OPTIONS = [
    {label: '$100', value: '100'},
    {label: '$150', value: '150'},
    {label: '$200', value: '200'},
    {label: '$250', value: '250'},
    {label: '$300', value: '300'},
    {label: '$350', value: '350'},
    {label: '$400', value: '400'},
    {label: '$450', value: '450'},
    {label: '$500', value: '500'},
    {label: '$600', value: '600'},
    {label: '$700', value: '700'},
    {label: '$800', value: '800'},
    {label: '$900', value: '900'},
    {label: '$1,000', value: '1000'},
    {label: '$1,250', value: '1250'},
    {label: '$1,500', value: '1500'},
    {label: '$2,000', value: '2000'},
    {label: '$3,000', value: '3000'},
    {label: '$5,000', value: '5000'},
    {label: '$6,000', value: '6000'},
    {label: '$7,000', value: '7000'},
    {label: '$8,000', value: '8000'},
    {label: '$9,000', value: '9000'},
    {label: '$10,000', value: '10000'},
    {label: '$15,000', value: '15000'},
    {label: '$20,000', value: '20000'},
    {label: '$30,000', value: '30000'},
    {label: '$40,000', value: '40000'},
    {label: '$50,000', value: '50000'},
    {label: '$60,000', value: '60000'},
    {label: '$70,000', value: '70000'},
    {label: '$80,000', value: '80000'},
    {label: '$90,000', value: '90000'},
    {label: '$100,000', value: '100000'},
    {label: '$120,000', value: '120000'},
    {label: '$140,000', value: '140000'},
    {label: '$160,000', value: '160000'},
    {label: '$180,000', value: '180000'},
    {label: '$200,000', value: '200000'},
    {label: '$300,000', value: '300000'},
    {label: '$500,000', value: '500000'},
    {label: '$800,000', value: '800000'},
    {label: '$1,000,000', value: '1000000'},
    {label: '$5,000,000', value: '5000000'},
    {label: '$10,000,000', value: '10000000'},
];

export const OPTIONS = [
    {value: '0', label: '0'},
    {value: '1', label: '1'},
    {value: '2', label: '2'},
    {value: '3', label: '3'},
    {value: '4', label: '4'},
    {value: '5', label: '5'},
    {value: '6+', label: '6+'},
];

const FLOOR_AREA_OPTIONS = [
    { label: '100m\u00B2', value: '100' },
    { label: '200m\u00B2', value: '200' },
    { label: '300m\u00B2', value: '300' },
    { label: '400m\u00B2', value: '400' },
    { label: '500m\u00B2', value: '500' },
    { label: '600m\u00B2', value: '600' },
    { label: '700m\u00B2', value: '700' },
    { label: '800m\u00B2', value: '800' },
    { label: '900m\u00B2', value: '900' },
    { label: '1,000m\u00B2', value: '1000' },
    { label: '1,250m\u00B2', value: '1250' },
    { label: '1,500m\u00B2', value: '1500' },
    { label: '1,750m\u00B2', value: '1750' },
    { label: '2,000m\u00B2', value: '2000' },
];

export const OPTIONS_NO_PLUS = [
    {value: '0', label: '0'},
    {value: '1', label: '1'},
    {value: '2', label: '2'},
    {value: '3', label: '3'},
    {value: '4', label: '4'},
    {value: '5', label: '5'},
    {value: '6', label: '6'},
];

export const DATE_OPTIONS = [
    {
        label: 'Last Month',
        value: 1,
    },
    {
        label: 'Last 3 Months',
        value: 3,
    },
    {
        label: 'Last 6 Months',
        value: 6,
    },
    {
        label: 'Last 9 Months',
        value: 9,
    },
    {
        label: 'Last 12 Months',
        value: 12,
    },
    {
        label: 'Last 18 Months',
        value: 18,
    },
    {
        label: 'Last 24 Months',
        value: 24,
    },
];

export const STREET_FRONTAGE_OPTIONS = [
    {
        label: '0.5m',
        value: 0.5,
    },
    {
        label: '1m',
        value: 1,
    },
    {
        label: '2m',
        value: 2,
    },
    {
        label: '2.5m',
        value: 2.5,
    },
    {
        label: '5m',
        value: 5,
    },
    {
        label: '10m',
        value: 10,
    },
    {
        label: '25m',
        value: 25,
    },
    {
        label: '50m',
        value: 50,
    },
];

export const RADIUS_OPTIONS = [
    {
        label: '0.5Km',
        value: 0.5,
    },
    {
        label: '1Km',
        value: 1,
    },
    {
        label: '2Km',
        value: 2,
    },
    {
        label: '2.5Km',
        value: 2.5,
    },
    {
        label: '5Km',
        value: 5,
    },
    {
        label: '10Km',
        value: 10,
    },
    {
        label: '25Km',
        value: 25,
    },
    {
        label: '50Km',
        value: 50,
    },
    {
        label: '75Km',
        value: 75,
    },
    {
        label: '100Km',
        value: 100,
    },
];

export const AREA_OPTIONS = [
    { label: '100', value: '100' },
    { label: '200', value: '200' },
    { label: '300', value: '300' },
    { label: '400', value: '400' },
    { label: '500', value: '500' },
    { label: '600', value: '600' },
    { label: '700', value: '700' },
    { label: '800', value: '800' },
    { label: '900', value: '900' },
    { label: '1,000', value: '1000' },
    { label: '1,250', value: '1250' },
    { label: '1,500', value: '1500' },
    { label: '1,750', value: '1750' },
    { label: '2,000', value: '2000' },
    { label: '5,000', value: '5000' },
    { label: '7,500', value: '7500' },
];

export const MIN_OPTION = {value: '', label: 'Min'};
export const MAX_OPTION = {value: '', label: 'Max'};

export const ONE_TO_SIX_OPTIONS_MIN = [
    MIN_OPTION,
    ...OPTIONS_NO_PLUS,
];
export const ONE_TO_SIX_OPTIONS_MAX = [
    MAX_OPTION,
    ...OPTIONS_NO_PLUS,
];

export const ZERO_TO_SIX_PLUS_OPTIONS_MIN = [
    MIN_OPTION,
    ...OPTIONS,
];
export const ZERO_TO_SIX_PLUS_OPTIONS_MAX = [
    MAX_OPTION,
    ...OPTIONS,
];

export const PRICE_OPTIONS_MIN = [
    MIN_OPTION,
    ...SALE_PRICE_OPTIONS,
];

export const PRICE_OPTIONS_MAX = [
    MAX_OPTION,
    ...SALE_PRICE_OPTIONS,
];

export const RENTAL_PRICE_OPTIONS_MIN = [
    MIN_OPTION,
    ...RENTAL_PRICE_OPTIONS,
];
export const RENTAL_PRICE_OPTIONS_MAX = [
    MAX_OPTION,
    ...RENTAL_PRICE_OPTIONS,
];

export const AREA_OPTIONS_MIN = [
    MIN_OPTION,
    ...AREA_OPTIONS,
];
export const AREA_OPTIONS_MAX = [
    MAX_OPTION,
    ...AREA_OPTIONS,
];

export const FLOOR_AREA_MIN_OPTIONS = [
    MIN_OPTION,
    ...FLOOR_AREA_OPTIONS,
];
export const FLOOR_AREA_MAX_OPTIONS = [
    MAX_OPTION,
    ...FLOOR_AREA_OPTIONS,
];

export const DISTANCE_OPTIONS_MIN = [
    MIN_OPTION,
    {
        label: '0.5Km',
        value: 0.5,
    },
    {
        label: '1Km',
        value: 1,
    },
    {
        label: '2Km',
        value: 2,
    },
    {
        label: '2.5Km',
        value: 2.5,
    },
    {
        label: '5Km',
        value: 5,
    },
    {
        label: '10Km',
        value: 10,
    },
    {
        label: '25Km',
        value: 25,
    },
    {
        label: '50Km',
        value: 50,
    },
];
export const DISTANCE_OPTIONS_MAX = [
    MAX_OPTION,
    {
        label: '0.5Km',
        value: 0.5,
    },
    {
        label: '1Km',
        value: 1,
    },
    {
        label: '2Km',
        value: 2,
    },
    {
        label: '2.5Km',
        value: 2.5,
    },
    {
        label: '5Km',
        value: 5,
    },
    {
        label: '10Km',
        value: 10,
    },
    {
        label: '25Km',
        value: 25,
    },
    {
        label: '50Km',
        value: 50,
    },
];

export const STREET_FRONTAGE_OPTIONS_MIN = [
    MIN_OPTION,
    ...STREET_FRONTAGE_OPTIONS,
];
export const STREET_FRONTAGE_OPTIONS_MAX = [
    MAX_OPTION,
    ...STREET_FRONTAGE_OPTIONS,
];

export const COMMERCIAL_RANGE_LABELS = {
    factoryArea: 'M2 of Factory Space',
    mezzanineArea: 'M2 of Mezzanine Space',
    officeShowroomArea: 'M2 of Office/Showroom Space',
    otherArea: 'M2 of Other Space',
    shopArea: 'M2 of Shop Space',
    showroomArea: 'M2 of Showroom Space',
    warehouseArea: 'M2 of Warehouse Space',
    workshopArea: 'M2 of Workshop Space',
};

export const DISTANCE_LABELS = {
    distanceToHospital: 'Distance to Hospital (km)',
    distanceToRiverFrontage: 'Distance to River Frontage (km)',
    distanceToSchool: 'Distance to School (km)',
    distanceToSeaRiverCanal: 'Distance to Sea/River/Canal (km)',
    distanceToShops: 'Distance to Shops (km)',
};

export const EXTERNAL_CHECKBOX_FILTER_LABELS = {
    boatRampMooringSpace: 'Boat Ramp/Mooring/Space',
    fenced: 'Fenced',
    grannyFlatSelfContained: 'Granny Flat/Self Contained',
    swimmingPool: 'Swimming Pool',
    treesOnLand: 'Trees on Land',
};

export const EXTERNAL_RANGE_FILTER_LABELS = {
    lockupGarages: 'Lockup Garage',
    noOfTennisCourts: 'Tennis Courts',
};

export const EXTERNAL_TEXTFIELD_FILTER_LABELS = {
    materialsInExternalWalls: 'Materials in External Walls',
    materialsInRoof: 'Materials in Roof',
};

export const EXTERNAL_TEXTFIELD_FILTER_LABELS_NZ = {
    wallMaterial: 'Materials in External Walls',
    roofMaterial: 'Materials in Roof',
};

export const FRONTAGE_FILTER_LABELS = {
    canalFrontage: 'Canal Frontage',
    coastFrontage: 'Coast Frontage',
    golfFrontage: 'Golf Frontage',
    highExposure: 'High Exposure',
    lakeFrontage: 'Lake Frontage',
    riverFrontage: 'River Frontage',
    scenicView: 'Scenic View',
    waterFrontage: 'Water Frontage',
};

export const INTERNAL_CHECKBOX_FILTER_LABELS = {
    airConditioned: 'Air Conditioned',
    builtInWardrobes: 'Built In Wardrobes',
    ductedHeating: 'Ducted Heating',
    ductedVacuum: 'Ducted Vacuum',
    fireplace: 'Fireplace',
    openPlan: 'Open Plan',
    polishedFloors: 'Polished Floors',
    renovated: 'Renovated',
};

export const INTERNAL_RANGE_FILTER_LABELS = {
    diningRooms: 'Dining Rooms',
    familyRumpusRooms: 'Family/Rumpus Rooms',
    floorLevelsInside: 'Floor Levels Inside',
    kitchens: 'Kitchens',
    loungeRooms: 'Lounge Rooms',
    loungeDiningRoomsCombined: 'Lounge/Dining Rooms Combined',
    noOfStudyRooms: 'No. of Study',
    toilets: 'Toilets',
};

export const FEE_CODE_OPTIONS = [
    { label: 'Select', value: '' },
    { label: 'Exempt', value: 'Exempt' },
    { label: 'Freehold', value: 'Freehold' },
    { label: 'Freehold/Leasehold', value: 'Freehold/Leasehold' },
    { label: 'Leasehold', value: 'Leasehold' },
    { label: 'State Land', value: 'State Land' },
];

export const RURAL_RANGE_FILTER_LABELS = {
    housesOnFarm: 'Houses on Farm',
    irrigatedArea: 'Irrigated Area',
    damsBores: 'No. of Dams/Bores',
    paddocksYards: 'Number of Paddocks/Yards',
};

export const RURAL_CHECKBOX_FILTER_LABELS = {
    allWeatherAccessToLand: 'All Weather Access to Land',
    allWeatherRoadsToFarm: 'All Weather Roads to Farm',
    permanentWater: 'Permanent Water',
    sealedRoadsToProperty: 'Sealed Roads to Property'
};

export const SERVICE_FILTER_LABELS = {
    accessAvailable24Hrs: '24 Hour Access Available',
    accessSecurityInstalled: 'Access Security Installed',
    closeToPublicTransport: 'Close to Public Transport',
    liftInstalled: 'Lift Installed',
    onMainRoad: 'On Main Road',
    sewage: 'Sewage',
    townSewerageAvailable: 'Town Sewerage Available',
    townWaterAvailable: 'Town Water Available',
    water: 'Water',
};

export const FILTERS = {
    LAND_USE: 'filters/land_use.json',
    DEV_ZONE: 'filters/dev_zone.json',
    PROPERTY_SUB_TYPE: 'filters/property_sub_type.json',
};

export const FILTERS_NZ = {
    LAND_USE: 'filters/land_use_nz.json',
    DEV_ZONE: 'filters/dev_zone_nz.json',
    PROPERTY_SUB_TYPE: 'filters/property_sub_type_nz.json',
};

export const CHECKBOX_FILTERS = {
    propertySubType: { key: 'propertySubType', label: 'Property Sub Type', placeholder: 'Search for property sub type' },
    landUse: { key: 'landUse', label: 'Land Use', placeholder: 'Search for land use' },
    devZone: { key: 'devZone', label: 'Development Zone', placeholder: 'Search for a development zone' },
};

export const FREQUENCIES = {
    week: 'Weekly',
    month: 'Monthly',
    year: 'Yearly',
};

export const FREQUENCY_VALUES_AU = {
    [FREQUENCIES.week]: 'weekly',
    [FREQUENCIES.month]: 'monthly',
    [FREQUENCIES.year]: 'annually',
};

export const FREQUENCY_VALUES_NZ = {
    [FREQUENCIES.week]: 'week',
    [FREQUENCIES.month]: 'month',
    [FREQUENCIES.year]: 'year',
};

export const FREQUENCY_VALUES = isNZLocale() ? FREQUENCY_VALUES_NZ : FREQUENCY_VALUES_AU;

export const SALES_CLASSIFICATION_OPTIONS = [
    { label: 'Select', value: '' },
    { label: 'Market Index', value: 'Market Index' },
    { label: 'Non-Market', value: 'Non-Market' },
    { label: 'Market Non-Index', value: 'Market Non-Index' },
    { label: 'Not Classified', value: 'Not Classified' },
];

export const FREQUENCY_OPTIONS = Object.values(FREQUENCIES);